import $ from "jquery";
import { cookieManager } from "../cookies/cookieManager";
export const checkboxValueCookie = {
    init: () => {
        checkboxValueCookie.enableGlobal();
        $("[data-checkbox-key-cookie]").each(function () {
            const $thisElement = $(this);
            const typeCookie = $thisElement.data("checkbox-cookie-type");
            const targetCookie = $thisElement.data("checkbox-key-cookie");
            const valueCookie = $thisElement.data("checkbox-value-cookie");
            switch (typeCookie) {
                case "exclusion": {
                    const exclusionCookie = cookieManager.cookie(targetCookie);
                    const hasExclusionCookie = exclusionCookie !== null;
                    const hasConfirmChoise = cookieManager.cookie("insight-us-confirm-choice") !== null;
                    const hasAllowAllChoise = cookieManager.cookie("insight-us-allow-all") !== null;
                    if (!hasExclusionCookie && !hasConfirmChoise && !hasAllowAllChoise) {
                        return;
                    }
                    if (hasExclusionCookie) {
                        $(this).prop("checked", !exclusionCookie.includes(valueCookie));
                    }
                    else {
                        $(this).prop("checked", true);
                    }
                    break;
                }
                default:
                    break;
            }
        });
    },
    enableGlobal: () => {
        if (!window["checkboxValueCookie"]) {
            window["checkboxValueCookie"] = checkboxValueCookie;
        }
    },
};
